export default {
  clientId: '9191bb36a26869917a98',
  clientSecret: 'b52cc04c678c8c615dbe16429952e416ee5f7702'
}
